import type { IPathBaseParam } from "./path";

import { createPostApi } from "@api/util/createPostApi";
import type { IApiResponse } from "@/api";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  undefined
>("channels.messages.markAsRead");

export const markAsRead = {
  ...postApis,
};
